import { createUniqKey } from 'Utils';
import { STATUS }        from '../Status/Status';
import User, { IUser }   from '../User/User';

export interface IInvoice {
  id: string,
  // user: string,
  invoiceNumber: string,
  invoiceDate: Date | null,
  shippingFirstname: string,
  shippingLastname: string,
  shippingStreet: string,
  shippingCity: string,
  shippingPostcode: string,
  shippingAdditionalLine1: string,
  shippingAdditionalLine2: string,
  totalAmount: number,
  totalFee: number,
  transactionCosts: number,
  totalFeeTax: number,
  tax: number,
  totalFeeWithoutTax: number,
  shippingCost: number,
  status: keyof typeof STATUS,
  stripeTransferGroup: string,
  payedAt: Date | null,
  user: IUser|null,
}

export class Invoice {
  public _key: string;
  public id: string;
  // public user: string;
  public invoiceNumber: string;
  public invoiceDate: Date | null;
  public shippingFirstname: string;
  public shippingLastname: string;
  public shippingStreet: string;
  public shippingCity: string;
  public shippingPostcode: string;
  public shippingAdditionalLine1: string;
  public shippingAdditionalLine2: string;
  public totalAmount: number;
  public totalFee: number;
  public transactionCosts: number;
  public totalFeeTax: number;
  public tax: number;
  public totalFeeWithoutTax: number;
  public shippingCost: number;
  public status: keyof typeof STATUS;
  public stripeTransferGroup: string;
  public payedAt: Date | null;
  public user: User | null;

  constructor(data: IInvoice) {
    this._key = createUniqKey();
    this.id = data.id;

    this.invoiceNumber = data.invoiceNumber;
    this.invoiceDate = data.invoiceDate ? new Date(data.invoiceDate as unknown as number * 1000) : null;
    this.shippingFirstname = data.shippingFirstname;
    this.shippingLastname = data.shippingLastname;
    this.shippingStreet = data.shippingStreet;
    this.shippingCity = data.shippingCity;
    this.shippingPostcode = data.shippingPostcode;
    this.shippingAdditionalLine1 = data.shippingAdditionalLine1;
    this.shippingAdditionalLine2 = data.shippingAdditionalLine2;
    this.totalAmount = parseInt(`${data.totalAmount || 0}`);
    this.totalFee =  parseInt(`${data.totalFee || 0}`);
    this.transactionCosts = parseInt(`${data.transactionCosts || 0}`);
    this.totalFeeTax = parseInt(`${data.totalFeeTax || 0}`);
    this.tax = parseInt(`${data.tax || 0}`);
    this.totalFeeWithoutTax = parseInt(`${data.totalFeeWithoutTax || 0}`);
    this.shippingCost = parseInt(`${data.shippingCost || 0}`);
    this.status = data.status;
    this.stripeTransferGroup = data.stripeTransferGroup;
    this.payedAt = data.payedAt;

    this.user = data.user ? new User(data.user) : null;

  }
}

export const createNewOInvoice = (data: Partial<IInvoice> = {}): Invoice => new Invoice({
  id: data.id || 'new',
  invoiceNumber: data.invoiceNumber || '',
  invoiceDate: data.invoiceDate || null,
  shippingFirstname: data.shippingFirstname || '',
  shippingLastname: data.shippingLastname || '',
  shippingStreet: data.shippingStreet || '',
  shippingCity: data.shippingCity || '',
  shippingPostcode: data.shippingPostcode || '',
  shippingAdditionalLine1: data.shippingAdditionalLine1 || '',
  shippingAdditionalLine2: data.shippingAdditionalLine2 || '',
  totalAmount: data.totalAmount || 0,
  totalFee: data.totalFee || 0,
  transactionCosts: data.transactionCosts || 0,
  totalFeeTax: data.totalFeeTax || 0,
  tax: data.tax || 19,
  totalFeeWithoutTax: data.totalFeeWithoutTax || 0,
  shippingCost: data.shippingCost || 0,
  status: data.status || STATUS.PENDING,
  stripeTransferGroup: data.stripeTransferGroup || '',
  payedAt: data.payedAt || null,
  user: data.user || null,
});
